import { useEffect,useState } from "react";

export function useAdobeLaunch(){
    const isAdobe =  window.globalConfig.UseAdobeLaunch;
    const [loaded,setLoaded] = useState(false);
    useEffect(()=>{
        switch(isAdobe){
            case 0 : 
                //Both Off
                console.log('case 0');
                break;
            case 1: 
                //Use WA
                console.log('case1');
                var script = document.createElement('script');
                script.src = window.globalConfig.WAConfig.visitor;
                document.head.appendChild(script);
                const script2 = document.createElement('script');
                script.src = window.globalConfig.WAConfig.tracker;
                document.head.appendChild(script2);
                const script3 = document.createElement('script');
                script.src = window.globalConfig.WAConfig.tracker_config;
                document.head.appendChild(script3);
                break;
            case 2:
                //Use Adobe Launch
                // console.log('case2')
                // var script = document.createElement('script');
                // script.src = window.globalConfig.AdobeLaunchURL;
              
                // script.onload = () => {
                //     setLoaded(true); // Script is loaded and executed
                // };
                // script.onerror = () => {
                //     console.error('Script failed to load');
                //     setLoaded(false);
                // };
                // document.head.appendChild(script);
                break;
            default:
                break;
        }
    },[])
    return loaded
}